import { render, staticRenderFns } from "./CustomCollapseTransition.vue?vue&type=template&id=2dc3115a"
import script from "./CustomCollapseTransition.vue?vue&type=script&lang=js"
export * from "./CustomCollapseTransition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports